<template>
    <div>
<!--        <div>-->
<!--            <h2>Search and add a pin</h2>-->
<!--            <label>-->
<!--                <gmap-autocomplete-->
<!--                        @place_changed="setPlace">-->
<!--                </gmap-autocomplete>-->
<!--                <button @click="addMarker">Add</button>-->
<!--            </label>-->
<!--            <br/>-->

<!--        </div>-->
        <br>
        <gmap-map
                :center="center"
                :zoom="18"
                style="width:100%;  height: 500px;">
            <gmap-marker
                    :position="marker"
                    @click="center=m.position"
                    icon="img/brand/Bino.svg"
                    title="Bosh Prokuratura"
            ></gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
    export default {
        name: "GoogleMap",
        data() {
            return {
                // default to Montreal to keep it simple
                // change this to whatever makes sense
                center: { lat: 41.307502, lng: 69.287701 },
                marker: {
                    lat: 41.307502,
                    lng: 69.287701
                },
                places: [],
                currentPlace: null
            };
        },

        mounted() {
            this.geolocate();
        },

        methods: {
            // receives a place object via the autocomplete component
            setPlace(place) {
                this.currentPlace = place;
            },
            addMarker() {
                if (this.currentPlace) {
                    const marker = {
                        lat: this.currentPlace.geometry.location.lat(),
                        lng: this.currentPlace.geometry.location.lng()
                    };
                    this.markers.push({ position: marker });
                    this.places.push(this.currentPlace);
                    this.center = marker;
                    this.currentPlace = null;
                }
            },
            geolocate: function() {
                navigator.geolocation.getCurrentPosition(position => {
                    this.center = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                });
            }
        }
    };
</script>